export const messages = {
    'appExternalSuccessMessage.back': 'Back to login page',
    'avatar.alt': 'User avatar',
    'confirmationModal.default.cancelText': 'Cancel',
    'confirmationModal.default.confirmText': 'Confirm',
    'expandableList.toggleButton': (isLimit: boolean) => `Show ${isLimit ? 'more' : 'less'}`,
    'noResultsView.text': (entityName: string) => `There are no ${entityName} matching the selected parameters.`,
    'searchForm.placeholder': 'Search',
    'usersSummary.editGroup': 'Edit group',
    'usersSummary.allUsers': 'All users',
    'usersSummary.usersWithoutGroup': 'Ungrouped users',
    'usersSummary.active.title': 'Active',
    'usersSummary.active.text': (count: number | string) => `${count} ${count == 1 ? 'Player' : 'Players'}`,
    'usersSummary.managed.title': 'Managed by',
    'usersSummary.managed.text': (count: number | string) => `${count} ${count == 1 ? 'Manager' : 'Managers'}`,
    'usersSummary.access.title': 'Access to',
    'usersSummary.access.text': (count: number | string) => `${count} ${count == 1 ? 'Procedure' : 'Procedures'}`,
    'tablePagination.summary': (current: number, total: number) => `Page ${current} of ${total}`,
    'tableSort.label': 'Sort by',
    'tableSort.none': 'No sorting',
    'tableSort.toggleDirection': 'Toggle sort direction',
    'tableCard.toggleDetails': 'Toggle details',
    'orientationGuard.title': 'Please rotate your device',
    'orientationGuard.text': 'This app works best in portrait mode on phones. Rotate your device to continue.',
    'dateRange.lastWeek': 'Last week',
    'dateRange.lastMonth': 'Last month',
    'dateRange.lastThreeMonths': 'Last three months',
    'dateRange.lastYear': 'Last year',
    'dateRange.allTime': 'All time',

    'executionModes.Automatic.initial': 'A',
    'executionModes.Automatic.title': 'Automatic',
    'executionModes.Automatic.description': 'The procedure will be performed automatically. User interaction is not required.',

    'executionModes.Guided.initial': 'G',
    'executionModes.Guided.title': 'Guided',
    'executionModes.Guided.description': 'The procedure will be performed by the user step by step with the assistance from the system.',

    'executionModes.Feedback.initial': 'F',
    'executionModes.Feedback.title': 'Feedback (Assessment)',
    'executionModes.Feedback.description': 'The procedure will be performed independently by the user, without assistance from the system. This mode is intended for evaluation purposes.',

    'executionModes.Enabled?.initial': 'S',
    'executionModes.Enabled?.title': 'Standard',
    'executionModes.Enabled?.description': 'The standard execution of a non virtual training procedure',
}
